








import Vue from "vue"
import PTopMenuTag from "./PTopMenuTag.vue"

export default Vue.extend({
  components: {
    PTopMenuTag,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    copyLink() {
      const baseUrl = process.env.SERVICE_BASE_URL
      const link = `${baseUrl}/projects/${this.projectId}`
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$clStores.flashMessage.actions.drawFlashSuccess(
            "プロジェクトのリンクをコピーしました"
          )
        })
        .catch(() => alert("リンクのコピーに失敗しました。"))
    },
  },
})
